import dayjs, { Dayjs } from 'dayjs';
import { Api, ApiConfig } from '@api';

class TimeService {
  private localTimeAndServerTimeDiff = 0;
  private serverTime: Dayjs | null = null;
  private MAX_TIME_INTERVAL = 5 * 60 * 1000;

  updateTime(resTime: string) {
    if (resTime && dayjs(resTime, 'YYYYMMDDHHmmss').isValid()) {
      this.serverTime = dayjs(resTime, 'YYYYMMDDHHmmss');
      this.localTimeAndServerTimeDiff = this.serverTime.diff(dayjs());
    }
  }

  getTime() {
    // 如果第一次进入没有服务器时间就取本地时间并更新服务器时间
    if (this.serverTime === null || this.localTimeAndServerTimeDiff === 0) {
      return dayjs();
    }
    // 如果获取时间超过五分钟，就刷新一次时间差
    console.log(dayjs().diff(this.serverTime));
    const time = dayjs().add(this.localTimeAndServerTimeDiff, 'ms');
    // if (this.serverTime && time.diff(this.serverTime) > this.MAX_TIME_INTERVAL) {
    //   this.refreshServerTime();
    // }
    return time;
  }

  refreshServerTime() {
    Api.request(ApiConfig.getServerTime).then(
      (res) => {
        console.log(res);
        this.updateTime(res);
      },
      () => {},
    );
  }
}

export default new TimeService();
